import ServiceRegistry from "./service-registry";
import AuthenticationService from "./authentication-service";
import stretchliveApiEndpoints from "./stretchlive-api-endpoints";

const apiInstance = ServiceRegistry.createService(
	process.env.REACT_APP_STRETCHLIVE_API_ENDPOINT,
	AuthenticationService
);

class StretchLiveApiClient {
	constructor() {
		this.stretchliveApiEndpoints = stretchliveApiEndpoints;
	}

	getStreamSrcById = async (id) => {
		const { data } = await apiInstance.get(
			this.stretchliveApiEndpoints.EVENT_BY_MEDIA(id, "video")
		);

		return data.url;
	};
}

export default new StretchLiveApiClient();
